import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { dateFormat, Plan } from '../../../core';
import { AnatomicalSideLabelPipe, BaseComponent, BoneTypeLabelPipe, ConvertDatePipe } from '../../../shared';


/**
 * Component for template of preop plan.
 */
@Component({
	selector: 'prt-template',
	templateUrl: './prt-template.component.html',
	imports: [
		ConvertDatePipe,
		BoneTypeLabelPipe,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrtTemplateComponent extends BaseComponent {

	@Input() isDemo = false;
	@Input() today: Date | null = null;
	@Input() plan?: Plan;

	readonly dateFormat = dateFormat();

}
